import { IVideo } from '@medlogic/shared/shared-interfaces';
import { EntityState } from '@ngrx/entity';

export interface ITutorialState extends EntityState<IVideo> {
    // additional entities state properties
    error: any;
    selectedId: number | null;
}